<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Tabs" pageTitle="Tabs" />
            <TabsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import TabsContent from '../Tabs/TabsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'TabsPage',
    components: {
        MainHeader,
        PageTitle,
        TabsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>